import { Component, Injector, OnInit } from '@angular/core';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { Validators } from '@angular/forms';
import { minArrayLengthValidator } from 'src/app/shared/forms/validators/minarraylengthvalidator/minarraylengthvalidator';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { ParkinglotselectorComponent } from 'src/app/features/parking/parking/parkinglots/modals/parkinglotselector/parkinglotselector.component';

@Component({
    selector: 'app-editvaletstation',
    templateUrl: './editvaletstation.component.html',
    styleUrls: ['./editvaletstation.component.scss'],
    standalone: false
})
export class EditValetStationComponent extends ModelEditor implements OnInit {
  public ValetTypes: any[] = [];

  // Mirror of FrogOne.ModelDefinitions.Parking.Valet.ValetStationPaymentTerminalType
  public TerminalTypes: { Id: number, Name: string }[] = [
    { Id: 0, Name: 'Windcave HIT' }
  ];

  // Discriminator value for WindcaveHIT (mirrors enum value)
  public readonly WindcaveHITTerminalType = 0;

  constructor(private modalService: SimpleModalService, private apiService: ApiServiceBase, private injector: Injector) {
    super("valet/stations", injector);
  }

  public override DefaultModel(): any {
    return {
      Name: "",
      HighVolumeModeEnabled: false,
      SendSmsSurvey: false,
      SurveyDelay: 0,
      ExpectedWaitTime: 0,
      DefaultValetTypeId: null,
      ParkingLots: [],
      PaymentTerminals: []
    };
  }

  public override AfterModelLoaded(): void {
    this.FormArray(this.Form, 'ParkingLots').addValidators(minArrayLengthValidator(1));
    this.FormArray(this.Form, 'ParkingLots').updateValueAndValidity();

    //SurveyDelay's input is hidden when SendSmsSurvey is off, so it must only be required
    //while surveys are enabled or a cleared value would block saving with no visible error
    this.SyncSurveyDelayValidators(this.Form.get('SendSmsSurvey')?.value == true);
    this.Form.get('SendSmsSurvey')?.valueChanges.subscribe((enabled: boolean) => {
      this.SyncSurveyDelayValidators(enabled == true);
    });

    this.apiService.Get("valet/types").then((result: any) => {
      this.ValetTypes = result;
    });
  }

  /**
   * Applies the SurveyDelay validator set for the current SendSmsSurvey state: required only
   * while SMS surveys are enabled, minimum of zero always.
   */
  private SyncSurveyDelayValidators(smsSurveyEnabled: boolean): void {
    const surveyDelay = this.Form.get('SurveyDelay');
    if (!surveyDelay) {
      return;
    }
    surveyDelay.setValidators(smsSurveyEnabled ? [Validators.required, Validators.min(0)] : [Validators.min(0)]);
    surveyDelay.updateValueAndValidity();
  }

  public override BeforeSave(): void {

  }

  public override Validators(): any {
    return {
      'Name': [Validators.required, Validators.maxLength(128)],
      //required is applied conditionally in SyncSurveyDelayValidators based on SendSmsSurvey
      'SurveyDelay': [Validators.min(0)],
      'ExpectedWaitTime': [Validators.min(0)],
      'PaymentTerminals.SerialNumber': [Validators.required, Validators.maxLength(32)],
      'PaymentTerminals.DeviceId': [Validators.required, Validators.maxLength(32)],
      'PaymentTerminals.PosName': [Validators.required, Validators.maxLength(32)]
    };
  }

  public AddParkingLot(): void {
    this.modalService.addModal(ParkinglotselectorComponent, {})
      .subscribe((result) => {
        if (result != null) {
          if (this.CheckFormArrayContains(this.FormArray(this.Form, "ParkingLots"), 'ParkingLotId', result.Id) == false) {
            let newLot = { Id: 0, ParkingLotId: result.Id, ParkingLotName: result.Name };
            this.AddToFormArray(this.FormArray(this.Form, "ParkingLots"), newLot, "ParkingLots");
          }
        }
      });
  }

  public RemoveParkingLot(index: number): void {
    let fa = this.FormArray(this.Form, "ParkingLots");
    this.RemoveFromFormArray(fa, index);
    fa.markAsDirty();
  }

  public AddPaymentTerminal(terminalType: number): void {
    let fa = this.FormArray(this.Form, "PaymentTerminals");
    let newTerminal: any = {
      Id: 0,
      TerminalType: terminalType,
      SerialNumber: "",
      DeviceId: "",
      PosName: ""
    };
    this.AddToFormArray(fa, newTerminal, "PaymentTerminals");
    fa.markAsDirty();
  }

  public RemovePaymentTerminal(index: number): void {
    let fa = this.FormArray(this.Form, "PaymentTerminals");
    this.RemoveFromFormArray(fa, index);
    fa.markAsDirty();
  }

  public TerminalTypeName(terminalType: number): string {
    let match = this.TerminalTypes.find(t => t.Id == terminalType);
    return match ? match.Name : 'Unknown';
  }
}
